var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.article)?_c('ArticleCard',{key:_vm.article.title,staticClass:"mx-5 my-2.5 w-full",attrs:{"article":_vm.article,"variant":"vertical","hide":['description', 'date'],"size":"full"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }